import { useState, useEffect } from 'react';
import { Download, Eye } from 'lucide-react';
import { getAdminResumes, downloadResume } from '../../services/api';

export default function AdminResumes() {
  const [resumes, setResumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getAdminResumes().then(res => { setResumes(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Posted Resumes ({resumes.length})</h2>
        </div>
        {resumes.length === 0 ? (
          <div className="empty-state"><h3>No resumes posted yet</h3><p>Resumes will appear here when candidates post them</p></div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr><th>Name</th><th>Email</th><th>Designation</th><th>Experience</th><th>Skills</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {resumes.map(r => (
                <tr key={r.id}>
                  <td style={{ fontWeight: 600 }}>{r.name}</td>
                  <td>{r.email}</td>
                  <td>{r.designation || '-'}</td>
                  <td>{r.experience || '-'}</td>
                  <td style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {r.skills || '-'}
                  </td>
                  <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => setSelected(r)}><Eye size={14} /> View</button>
                      <a href={downloadResume(r.resumePath)} target="_blank" rel="noreferrer">
                        <button className="btn-download"><Download size={14} /> Download</button>
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Resume Details</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div><strong>Name:</strong> {selected.name}</div>
              <div><strong>Email:</strong> {selected.email}</div>
              <div><strong>Phone:</strong> {selected.phone}</div>
              <div><strong>Designation:</strong> {selected.designation || 'Not specified'}</div>
              <div><strong>Experience:</strong> {selected.experience || 'Not specified'}</div>
              <div><strong>Skills:</strong> {selected.skills || 'Not specified'}</div>
              <div><strong>Posted on:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
              <div>
                <strong>Resume File:</strong>{' '}
                <a href={downloadResume(selected.resumePath)} target="_blank" rel="noreferrer"
                  style={{ color: '#2563eb', fontWeight: 600 }}>
                  Download {selected.resumeOriginalName}
                </a>
              </div>
            </div>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
